import React from 'react';

const GoToStart = () => {
  window.location = '/v/teamsport';

  return (
    <div className="teamsport_content">
      <div className="main_container">
          <p style={{ color: '#0CD428' }}>Redirecting...</p>
      </div>
    </div>
  );
};

export default GoToStart;
